import classNames from 'classnames';

import s from './styles.module.scss';
import UncheckableRadioItem from './uncheckableRadioItem';

import type { IFormSubItemProps, IOptionProps } from './types';
import type { FC } from 'react';

const RadioLineItem: FC<
  IFormSubItemProps & {
    generalName: string;
  }
> = ({ formik, option, generalName, requiredSymptomFields }) => {
  const onHandleFactors = (opt: IOptionProps, value: boolean) => {
    const { confirmedFactors, deniedFactors } = formik.values;

    if (value) {
      const newDeniedValues = deniedFactors?.filter(
        (factor: string) => factor !== opt.label,
      );

      formik.setFieldValue('confirmedFactors', [
        ...confirmedFactors,
        opt.label,
      ]);
      formik.setFieldValue('deniedFactors', newDeniedValues);
    } else {
      const newConfirmedValues = confirmedFactors?.filter(
        (factor: string) => factor !== opt.label,
      );

      formik.setFieldValue('confirmedFactors', newConfirmedValues);
      formik.setFieldValue('deniedFactors', [...deniedFactors, opt.label]);
    }
  };

  const onHandleSymptoms = (opt: IOptionProps, value: boolean) => {
    const fieldName = String(opt.value);

    if (
      requiredSymptomFields &&
      requiredSymptomFields.includes(fieldName) &&
      !formik.values.checkSymptoms
    ) {
      formik.setFieldValue('checkSymptoms', true);
    }

    const { confirmedSymptoms, deniedSymptoms } = formik.values;
    formik.setFieldValue('symptoms', [...confirmedSymptoms, ...deniedSymptoms]);

    if (value) {
      const newDeniedValues = deniedSymptoms?.filter(
        (symptom: string) => symptom !== opt.label,
      );

      formik.setFieldValue('confirmedSymptoms', [
        ...confirmedSymptoms,
        opt.label,
      ]);
      formik.setFieldValue('deniedSymptoms', newDeniedValues);
    } else {
      const newConfirmedValues = confirmedSymptoms?.filter(
        (symptom: string) => symptom !== opt.label,
      );

      formik.setFieldValue('confirmedSymptoms', newConfirmedValues);
      formik.setFieldValue('deniedSymptoms', [...deniedSymptoms, opt.label]);
    }
  };

  const onDeselectSymptoms = (opt: IOptionProps) => {
    const { confirmedSymptoms, deniedSymptoms } = formik.values;
    const newConfirmedValues = confirmedSymptoms?.filter(
      (symptom: string) => symptom !== opt.label,
    );
    const newDeniedValues = deniedSymptoms?.filter(
      (symptom: string) => symptom !== opt.label,
    );
    formik.setFieldValue('confirmedSymptoms', newConfirmedValues);
    formik.setFieldValue('deniedSymptoms', newDeniedValues);
  };

  const onDeselectFactors = (opt: IOptionProps) => {
    const { confirmedFactors, deniedFactors } = formik.values;
    const newDeniedValues = deniedFactors?.filter(
      (factor: string) => factor !== opt.label,
    );
    const newConfirmedValues = confirmedFactors?.filter(
      (factor: string) => factor !== opt.label,
    );
    formik.setFieldValue('confirmedFactors', newConfirmedValues);
    formik.setFieldValue('deniedFactors', newDeniedValues);
  };

  const isShowErrorMessage = Object.keys(formik.errors).includes(
    option.value as string,
  );

  const itemClassNames = classNames(s['radio-line'], {
    [s.error]:
      !!Object.keys(formik.errors).length &&
      option.required &&
      isShowErrorMessage,
  });

  return (
    <div className={itemClassNames}>
      <UncheckableRadioItem
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
        name={option.value as string}
        type="radio-line"
        formik={formik}
        value={formik.values[option.value as string]}
        onSelect={(value) =>
          generalName === 'symptoms'
            ? onHandleSymptoms(option, value)
            : onHandleFactors(option, value)
        }
        onDeselect={() => {
          generalName === 'symptoms'
            ? onDeselectSymptoms(option)
            : onDeselectFactors(option);
        }}
      />
      <div className={s['radio-label']}>
        {option.label}
        {option.required && <> ⚠️</>}
      </div>
    </div>
  );
};

export default RadioLineItem;
